export enum ProfileStatusEnum {
  Init = 0,
  Processing = 1,
  Approving = 2,
  Completed = 3,
  Rejected = 4,
  Cancel = 5,
  Expried = 6,
  Approved = 99, //only for filter
}

export enum ProfileTypeEnum {
  Verified = 0,
}

export enum ProfileTypeContractEnum {
  Individual = "cn",
  Business = "pn",
}

export enum ProfileParticipantTypeEnum {
  Single = 0,
  Organization = 1,
}

export enum ProfileParticipantStatusEnum {
  Init = 0,
  Approving = 1,
  Signed = 2,
  Expried = 3,
}
